'use strict';

var React = require('react');
var compose = require('../hoc/compose');
var template = require('./closeButton.rt');
var defaultSymbol = require('../panels/headerCloseButton.svg.js');
var displayNames = require('./displayNames');

var CloseButton = template;

CloseButton.displayName = displayNames.CLOSE_BUTTON;
CloseButton.propTypes = {
    onClick: React.PropTypes.func
};
CloseButton.defaultProps = {
    symbol: React.createElement(defaultSymbol)
};

module.exports = compose(CloseButton);


// WEBPACK FOOTER //
// ./~/wix-base-ui/lib/controls/closeButton.js